import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../../config.js';
import '../../components/MegaMenu.js';
import { infrastructure, moduleLoader } from '../../infrastructure.js';

/**
 * Mega-menu
 * @returns {TemplateResult}
 */
export default function renderMegaMenu(activeMenuItem) {
  moduleLoader.loadModule(config.sabrinaWidgetUrl);

  return html`
    <osk-mega-menu-wrapper
      .infrastructure=${infrastructure}
      active-item=${activeMenuItem}
    ></osk-mega-menu-wrapper>
  `;
}
